import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { insurancePlans } from '../mockData/insurance-plans-data';

const InsurancePlansApi = [
  rest.get(`${API_ROOT}libraries/insurance-plans`, (req, res, ctx) => res(ctx.json(insurancePlans))),
  rest.get(`${API_ROOT}libraries/insurance-plans/${insurancePlans[0].id}`, (req, res, ctx) => res(ctx.json(insurancePlans[0]))),
  rest.put(`${API_ROOT}libraries/insurance-plans/${insurancePlans[0].id}`, (req, res, ctx) => res(ctx.json(insurancePlans[0]))),
  rest.post(`${API_ROOT}libraries/insurance-plans`, (req, res, ctx) => res(ctx.json(insurancePlans[1]))),
  rest.delete(`${API_ROOT}libraries/insurance-plans/${insurancePlans[0].id}`, (req, res, ctx) => res(ctx.json(insurancePlans[0]))),
];

export default InsurancePlansApi;
